import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-16 md:mb-24">
          <span className="w-10 h-px bg-[#f5e6d3]" />
          <span className="font-display text-xs uppercase tracking-[0.3em] text-[#f5e6d3]">
            Kind words — 005
          </span>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className="bg-[#0a0a0a] p-10 md:p-14 flex flex-col gap-8"
            >
              <Quote size={28} className="text-[#f5e6d3]" />
              <p className="font-editorial italic text-2xl md:text-3xl leading-snug text-white/90">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-white/10">
                <div className="font-display text-sm uppercase tracking-[0.15em]">
                  {t.name}
                </div>
                <div className="font-body text-xs text-zinc-500 mt-1 uppercase tracking-wider">
                  {t.role}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
